export interface Video {
  productName: string
  productSku: string
  id: string
  url: string
  thumbnail: string
}

export const videoList: Video[] = [
  {
    productName: 'Match Lab Queratina',
    productSku: '56799',
    id: 'Hhb3seI_w_Y',
  },
  {
    productName: 'Floratta Red Passion',
    productSku: '59306',
    id: 'enPEhHCdtL0',
  },
  {
    productName: 'Pincéis acessíveis',
    productSku: '53906',
    id: 'QbQf_Xw8JaE',
  },
  {
    productName: 'Pincel de Maquiagem Espiral Acessível Articulado Make B.',
    productSku: '53906',
    id: 'oyqGfhFnY-0',
  },
  {
    productName: 'LANÇAMENTO Clash Desodorante Colônia 100ml',
    productSku: '50677',
    id: 'K4MNyomB8-s',
  },
  {
    productName: 'Sérum Botik Resveratrol E Silício',
    productSku: '55403',
    id: '3WYxWb7C2M0',
  },
].map((video) => ({
  ...video,
  url: `https://youtube.com/shorts/${video.id}`,
  thumbnail: `https://img.youtube.com/vi/${video.id}/sddefault.jpg`,
}))
